import { faLoader, faRobot } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Editor, JSONContent } from "@tiptap/core";
import { sampleSize } from "lodash-es";
import { nanoid } from "nanoid";
import { forwardRef, useState } from "react";
import { useParams } from "react-router-dom";
import { titleCase } from "title-case";

import { storeCollapsed } from "@/extensions/RoadmapList";
import { useActiveEditor, useCeramic, useQueries } from "@/hooks";

import styles from "./Page.module.scss";

interface SemanticBuddyProps extends React.SelectHTMLAttributes<HTMLButtonElement> {
  editor: Editor;
}

export default forwardRef<HTMLButtonElement, SemanticBuddyProps>(({ editor, ...props }, ref) => {
  let { projectId = "global-graph", pageId = "default" } = useParams();
  const { address } = useCeramic();

  const { activeEditor, setActiveEditor, id: activeId, setId } = useActiveEditor();

  const { getSimilarPapers } = useQueries();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const loadSimilar = async () => {
    setIsLoading(true);
    try {
      const response = await getSimilarPapers({ slug: projectId });
      console.log(response);
      const data: JSONContent = [
        { type: "paragraph" },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              marks: [{ type: "bold" }],
              text: "Related Papers:",
            },
          ],
        },
        { type: "bulletList", content: [] },
        { type: "paragraph" },
      ];
      sampleSize(response, 5).forEach((result) => {
        const blockId = nanoid();
        data[2].content?.push({
          type: "listItem",
          attrs: { blockId },
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: `${titleCase(result.title.toLowerCase())} (`,
                },
                {
                  type: "text",
                  marks: [
                    {
                      type: "link",
                      attrs: {
                        href: result.url,
                        target: "_blank",
                      },
                    },
                  ],
                  text: "Link",
                },
                { type: "text", text: ")" },
              ],
            },
            {
              type: "bulletList",
              content: [
                {
                  type: "listItem",
                  content: [
                    {
                      type: "paragraph",
                      content: [
                        {
                          type: "text",
                          marks: [{ type: "bold" }],
                          text: "Abstract: ",
                        },
                        {
                          type: "text",
                          text: result.abstract,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        });

        storeCollapsed(blockId, true);
      });
      console.log(data);
      editor.chain().focus("end").createParagraphNear().insertContent(data).scrollIntoView().run();
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  return <></>;

  return (
    <button className={styles.semanticBuddy} {...props} onClick={loadSimilar} disabled={isLoading}>
      {isLoading ? (
        <>
          <FontAwesomeIcon icon={faLoader} spin /> Buddy is working
        </>
      ) : (
        <>
          <FontAwesomeIcon icon={faRobot} /> Semantic buddy
        </>
      )}
    </button>
  );
});
